import { Button, TextField } from '@mui/material';
import { setProperty } from '../../../../../common-utilities/utils/misc';
import { queryExtraCharges } from '../apis';
import { isCreateAllowed } from '../../../../utils/common-utils';
import { modalActions } from '../utils';

const HeaderSection = ({ filters, setFilters, setTableData, setModalDetails }) => {
  return (
    <div className="cl-header-section">
      <div className="left-container">
        <TextField
          placeholder="Search"
          value={filters?.searchKey || ''}
          size="small"
          onChange={(e) => {
            setProperty('searchKey', e.target.value, setFilters);
          }}
        />
        <Button
          variant="outlined"
          onClick={() => {
            queryExtraCharges(
              {
                ...filters,
                page: 1,
                limit: 10,
              },
              setTableData
            );
          }}
        >
          Search
        </Button>
      </div>
      <div className="left-container">
        {isCreateAllowed('master_data') && (
          <Button
            variant="outlined"
            onClick={() => {
              modalActions(null, 'CREATE', setModalDetails);
            }}
          >
            Create
          </Button>
        )}
      </div>
    </div>
  );
};

export default HeaderSection;
